import React from 'react'
import { useFutureSaleVehicles } from 'contexts'
import { Tooltip } from '@mui/material'
import UploadIcon from '@mui/icons-material/Upload'
import useDataTableUploadButton from './useDataTableUploadButton'

const DataTableUploadButton = () => {
  const { hasTask, handleChange } = useDataTableUploadButton()
  const { isModificationRestricted, modificationMessage } = useFutureSaleVehicles()
  const isDisabled = hasTask || isModificationRestricted

  return (
    <Tooltip
      title={modificationMessage}
      followCursor
      slotProps={{ popper: { style: { fontSize: '3rem' } } }}
    >
      <form className="flex items-center justify-center w-64 h-full">
        <input
          className="hidden"
          disabled={isDisabled}
          type="file"
          accept=".csv, .xls, .xlsx"
          id="upload"
          onChange={(e) => handleChange(e)}
        />
        <label
          htmlFor="upload"
          className={isDisabled ? 'text-gray-400 cursor-not-allowed' : 'cursor-pointer'}
        >
          <UploadIcon /> Import des réserves en masse
          {}
        </label>
      </form>
    </Tooltip>
  )
}

export default DataTableUploadButton
